<template>
  <div class="room-container">
    <div class="logo"></div>
    <p class="text-center">{{$t('chat.room.message')}}</p>
    <Spinner />
  </div>
</template>

<script>
import resources from "../../resources";
import Spinner from "../../components/Spinner";
export default {
  name: 'Room',
  components: { Spinner },
  mounted() {
    let roomId = this.$route.query.rid;
    let messageId = this.$route.query.mid;

    const chatEnabled = !!(process.env.VUE_APP_CHAT_ENABLED && process.env.VUE_APP_CHAT_ENABLED === 'true');
    const notificationsEnabled = !!(process.env.VUE_APP_NOTIFICATIONS_ENABLED && process.env.VUE_APP_NOTIFICATIONS_ENABLED === 'true');

    if(!notificationsEnabled){
      this.$router.replace({name: 'home'});
    }

    if(chatEnabled && notificationsEnabled) {
        resources.chat.getToken(roomId).then((response) => {
        if (!response.data.success) {
          this.$router.replace({name: 'home'});
          return;
        }
        let chatBaseUrl = response.data.chat_base_url;
        let token = response.data.token;
        window.location.href = chatBaseUrl+'/direct/'+roomId+'?resumeToken='+token+'&msg='+messageId;
      }).catch(() => {
        this.$router.replace({name: 'home'});
      });
    }
    else{
      this.$router.replace({name: 'home'});
    }
  }
}
</script>

<style scoped lang="scss">
.room-container {
  margin: 10% auto;

  .logo {
    height: 55px;
    width: 100%;
    background-image: var(--img-logo);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: auto;
  }

  .text-center {
    text-align: center;
  }

}
</style>
